import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  header: {
    background: 'linear-gradient(0deg, #F5F5F0 0%, #FFFFFF 100%)',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '2%',
    textAlign: 'center',
  },
  drawerContent: {
    marginTop: '150px',
  },
  footer: {
    background: '#FFFFFF',
    height: '8%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '75%',
    position: 'fixed',
    bottom: 0,
    left: '25%',
    padding: '10px 60px',
    [theme.breakpoints.down('md')]: {
      padding: '5px 30px',
    },
    boxShadow: '0px -5px 25px 0px rgba(0, 0, 0, 0.1)',
  },
  navigationButton: {
    [theme.breakpoints.up('md')]: {
      margin: '0 10% !important',
    },
    color: '#7B5599 !important',
    fontSize: '18px !important',
  },
  submitNavigationButton: {
    display: 'inline-flex',
    whiteSpace: 'nowrap',
    transition: 'all .24s ease-in-out',
    position: 'relative',
    height: '56px',
    lineHeight: '56px',
    [theme.breakpoints.up('md')]: {
      margin: '0 10px !important',
    },
    padding: '0px !important',
    color: '#fff !important',
    backgroundColor: '#7b5599 !important',
    fontSize: '18px !important',
    '& > span': {
      display: 'block',
      padding: '0 24px',
      flexGrow: 1,
    },
  },
  arrow: {
    alignContent: 'center',
    width: '48px',
    height: '56px',
    backgroundColor: 'hsla(0,0%,100%,.15) !important',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: '20px',
    textAlign: 'center',
    marginBottom: '12%',
    '&.margin': {
      [theme.breakpoints.down('md')]: {
        padding: '40px',
      },
    },
  },
  icon: {
    height: '100px !important',
    width: '100px !important',
    color: '#7B5599',
    [theme.breakpoints.down('sm')]: {
      height: '50px !important',
      width: '50px !important',
    },
  },
  pdfDownloader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    padding: '0 60px',
    [theme.breakpoints.down('md')]: {
      padding: '40px 80px',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '20px 60px',
    },
  },
  selectInvestmentAmountWrapper: {
    marginbottom: '20px',
    width: '100%',
  },
  investmentWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
  },
  errorMessage: {
    color: '#AB2B28',
    marginTop: '10px',
  },
  card: {
    border: '1px solid #D9D9D9',
    borderRadius: 10,
    margin: '25px 0px',
    alignItems: 'center',
    padding: 44,
    [theme.breakpoints.down('sm')]: {
      padding: 10,
      textAlign: 'center',
    },
  },
  description: {
    textAlign: 'left',
    paddingRight: '10%',
    [theme.breakpoints.down('md')]: {
      paddingRight: 'unset',
      paddingBottom: 20,
      textAlign: 'center',
    },
  },
  image: {
    height: '449px',
    width: '347px',
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      height: '302px',
      width: '233px',
    },
  },
}));

export default useStyles;
